(() => {
  const raf2 = (fn) => requestAnimationFrame(() => requestAnimationFrame(fn));

  const normalizeUrl = (url) => {
    if (!url) return null;
    if (url.startsWith("//")) return `https:${url}`;
    return url;
  };

  const applyGallery = (root, gallery) => {
    if (!gallery) return;
    const urls = Array.isArray(gallery.images) ? gallery.images.map(normalizeUrl) : [];

    root.querySelectorAll("[data-gallery-img]").forEach((img) => {
      const pos = parseInt(img.getAttribute("data-gallery-img"), 10);
      const url = urls[pos - 1];
      const wrapper = img.closest(".variant-gallery-grid__media");

      if (url) {
        img.src = url;
        if (wrapper) wrapper.style.display = "";
      } 
    });

    const bg = root.querySelector("[data-gallery-bg]");
    if (bg) bg.style.background = typeof gallery.bg_color === "string" ? gallery.bg_color : "";

    const headline = root.querySelector(".highlight-word");
    if (headline && typeof gallery.bg_color === "string") {
      headline.style.color = gallery.bg_color;
    }
  };

  const clearGallery = (root) => {
    root.querySelectorAll("[data-gallery-img]").forEach((img) => {
      img.removeAttribute("src");
      const wrapper = img.closest(".variant-gallery-grid__media");
    });
    const bg = root.querySelector("[data-gallery-bg]");
    if (bg) bg.style.background = "";
    const headline = root.querySelector(".highlight-word");
    if (headline) headline.style.color = "";
  };

  // ✅ IMPORTANT: /cart/add OU /en/cart/add -> action$="/cart/add"
  const CART_ADD_FORM_SELECTOR = 'form[action$="/cart/add"]';

  const getBestProductForm = (productId) => {
    const pid = String(productId);

    const forms = Array.from(document.querySelectorAll(CART_ADD_FORM_SELECTOR)).filter(
      (f) => f.querySelector('input[name="product-id"]')?.value === pid
    );

    if (!forms.length) return null;

    const withVariantClass = forms.find((f) => f.querySelector('input[name="id"].product-variant-id'));
    if (withVariantClass) return withVariantClass;

    const withId = forms.find((f) => f.querySelector('input[name="id"]'));
    return withId || forms[0];
  };

  const getVariantIdFromProductForm = (productId) => {
    const form = getBestProductForm(productId);
    if (!form) return null;

    const idInput =
      form.querySelector('input[name="id"].product-variant-id') ||
      form.querySelector('input[name="id"]');

    return idInput?.value ? String(idInput.value) : null;
  };

  const getMainSectionIdFromProductForm = (productId) => {
    const form = getBestProductForm(productId);
    if (!form) return null;

    const sid = form.querySelector('input[name="section-id"]')?.value;
    return sid ? String(sid) : null;
  };

  const getVariantIdFromVariantSelects = (mainSectionId) => {
    if (!mainSectionId) return null;

    const vs =
      document.getElementById(`variant-selects-${CSS.escape(String(mainSectionId))}`) ||
      document.querySelector(`variant-selects[data-section="${CSS.escape(String(mainSectionId))}"]`);

    if (!vs) return null;

    const json = vs.querySelector('script[type="application/json"][data-selected-variant]');
    if (!json) return null;

    try {
      const selected = JSON.parse(json.textContent || "{}");
      return selected?.id ? String(selected.id) : null;
    } catch (e) {
      console.warn("[vgg] invalid data-selected-variant json", e);
      return null;
    }
  };

  const initOne = (root) => {
    const jsonEl = root.querySelector('script[type="application/json"][data-gallery-json]');
    if (!jsonEl) return;

    let data;
    try {
      data = JSON.parse(jsonEl.textContent);
    } catch (e) {
      console.error("[variant-gallery-grid] Invalid JSON", e);
      return;
    }

    const productId = data?.productId;
    if (!productId) {
      console.error("[variant-gallery-grid] Missing productId in JSON");
      return;
    }

    const map = new Map();
    (data.variants || []).forEach((v) => map.set(String(v.id), v.gallery || null));

    let lastAppliedVariantId = null;

    const update = () => {
      const mainSectionId = getMainSectionIdFromProductForm(productId);

      const idFromVS = getVariantIdFromVariantSelects(mainSectionId);
      const idFromForm = getVariantIdFromProductForm(productId);
      const id = idFromVS || idFromForm;

      console.log("[vgg] product", productId, "mainSection", mainSectionId, "variant id =", id, {
        idFromVS,
        idFromForm,
      });

      if (!id) return;
      if (id === lastAppliedVariantId) return;

      const gallery = map.get(id);

      if (!gallery?.images?.length) {
        clearGallery(root);
        lastAppliedVariantId = id;
        return;
      }

      applyGallery(root, gallery);
      lastAppliedVariantId = id;
    };

    raf2(update);

    document.addEventListener("change", (event) => {
      const t = event.target;
      if (!(t instanceof Element)) return;

      if (t.matches('select[name^="options["], input[name^="options["]')) {
        raf2(update);
      }
    });

    document.addEventListener("variant-change", () => raf2(update));
    document.addEventListener("variant:change", () => raf2(update));
    document.addEventListener("variantChange", () => raf2(update));
    document.addEventListener("product:variant-change", () => raf2(update));

    const mainSectionId = getMainSectionIdFromProductForm(productId);
    if (mainSectionId) {
      const vs =
        document.getElementById(`variant-selects-${CSS.escape(String(mainSectionId))}`) ||
        document.querySelector(`variant-selects[data-section="${CSS.escape(String(mainSectionId))}"]`);

      const selectedJson = vs?.querySelector('script[type="application/json"][data-selected-variant]');
      if (selectedJson) {
        const mo = new MutationObserver(() => raf2(update));
        mo.observe(selectedJson, { childList: true, characterData: true, subtree: true });
      }
    }

    const form = getBestProductForm(productId);
    const idInput =
      form?.querySelector('input[name="id"].product-variant-id') ||
      form?.querySelector('input[name="id"]');

    if (idInput) {
      idInput.addEventListener("change", () => raf2(update));
      idInput.addEventListener("input", () => raf2(update));
    }
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll("[data-variant-gallery-grid]").forEach((root) => {
      if (root.__vgg) return;
      root.__vgg = true;
      initOne(root);
    });
  };

  document.addEventListener("DOMContentLoaded", () => initAll());
  document.addEventListener("shopify:section:load", (e) => initAll(e.target));
})();